/**
 * An Android intent link that opens `pageUrl` in Chrome; a browser that
 * cannot follow it stays on the page (the fallback URL is the page itself).
 */
export function buildChromeIntentUrl(pageUrl: string): string {
  const url = new URL(pageUrl)
  const target = `${url.host}${url.pathname}${url.search}`
  return `intent://${target}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(pageUrl)};end`
}
